import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceAlertsPanel = ({ alerts = [], loading = false }) => {
  const getPriorityStyles = (priority) => {
    switch (priority) {
      case 'critical':
        return {
          bg: 'bg-red-50',
          border: 'border-red-200',
          icon: 'text-red-600',
          text: 'text-red-800',
          badge: 'bg-red-100 text-red-700'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-50',
          border: 'border-yellow-200',
          icon: 'text-yellow-600',
          text: 'text-yellow-800',
          badge: 'bg-yellow-100 text-yellow-700'
        };
      case 'success':
        return {
          bg: 'bg-green-50',
          border: 'border-green-200',
          icon: 'text-green-600',
          text: 'text-green-800',
          badge: 'bg-green-100 text-green-700'
        };
      default:
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          icon: 'text-blue-600',
          text: 'text-blue-800',
          badge: 'bg-blue-100 text-blue-700'
        };
    }
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case 'underperforming':
        return 'TrendingDown';
      case 'high-performing':
        return 'TrendingUp';
      case 'execution-error':
        return 'AlertCircle';
      default:
        return 'Bell';
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'underperforming':
        return 'Bajo Rendimiento';
      case 'high-performing':
        return 'Alto Rendimiento';
      case 'execution-error':
        return 'Error de Ejecución';
      default:
        return type;
    }
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Bell" size={24} className="text-foreground" />
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Alertas de Rendimiento
          </h2>
        </div>
        <div className="flex justify-center py-8">
          <Icon name="Loader2" className="w-6 h-6 text-blue-600 animate-spin" />
        </div>
      </div>
    );
  }

  if (!alerts || alerts?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Bell" size={24} className="text-foreground" />
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Alertas de Rendimiento
          </h2>
        </div>
        <div className="text-center py-8 text-muted-foreground">
          <Icon name="CheckCircle" className="w-12 h-12 mx-auto mb-2 text-green-500" />
          <p className="text-sm">No hay alertas activas</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Bell" size={24} className="text-foreground" />
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Alertas de Rendimiento
          </h2>
        </div>
        <span className="text-xs text-muted-foreground">
          {alerts?.length} {alerts?.length === 1 ? 'alerta' : 'alertas'}
        </span>
      </div>

      <div className="space-y-3 max-h-96 overflow-y-auto">
        {alerts?.map((alert) => {
          const styles = getPriorityStyles(alert?.priority);
          return (
            <div
              key={alert?.id}
              className={`${styles?.bg} ${styles?.border} border rounded-lg p-3 transition-smooth hover:shadow-sm`}
            >
              <div className="flex items-start gap-3">
                <div className={`p-2 rounded-lg bg-white/50`}>
                  <Icon name={getAlertIcon(alert?.type)} size={18} className={styles?.icon} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`text-xs font-medium px-2 py-0.5 rounded ${styles?.badge}`}>
                      {getTypeLabel(alert?.type)}
                    </span>
                    <span className="text-xs text-muted-foreground truncate">
                      {alert?.ruleName}
                    </span>
                  </div>
                  <p className={`text-sm ${styles?.text} mb-1`}>
                    {alert?.message}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span>Métrica: {alert?.metric}</span>
                    <span>•</span>
                    <span>Valor: {alert?.value}%</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceAlertsPanel;